import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { FolioFisico, QrCargaMensaje } from "./folioFisico";
import { setState, state } from "app/resources/globals";

export interface Props {
    idDescarga: number;
}

export class Lector extends React.PureComponent<Props> {
    idDescarga = (props: Props) => props.idDescarga;
    resumen = createSelectorRx(this.idDescarga, id => observeResource(resources.DescargaZE.ObtenerResumen, id));
    dto = createSelectorRx(this.idDescarga, id => observeResource(resources.DescargaZE.Get, id));
    ultimoEscaneoGlobal = (props: Props) => state.map(x => x.ultimaLecturaDescargaZE);
    ultimoEscaneo = createSelectorRx(this.ultimoEscaneoGlobal, this.idDescarga, (ultimoEscaneo, id) => ultimoEscaneo && (
        ultimoEscaneo.idCargaDescarga == id ? ultimoEscaneo.lectura : null
    ));

    mensaje = createSelectorRx(this.resumen, this.dto, this.ultimoEscaneo, (resumen, dto, ultimoEscaneo) => ({
        camion: dto.PlacasVehiculo,
        cantGuias: resumen.CantidadGuias,
        cantServiciosIncompletos: resumen.CantidadServiciosIncompletos,
        ruta: "",
        ultimoEscaneo: ultimoEscaneo ? {
            guia: ultimoEscaneo.FolioGuia,
            numeroFisico: ultimoEscaneo.NumeroFisico,
            totalNumerosFisicos: ultimoEscaneo.TotalNumerosFisicos,
            tipo: ultimoEscaneo.Tipo == models.TipoFolioFisico.Paquete ? "paquete" : "sobre"
        } : null
    } as QrCargaMensaje));


    handleOnLectura = async (x: string) => {
        const lectura = await resources.DescargaZE.EscanearFolio(x, this.props.idDescarga);

        //Notificamos a la aplicación de la ultima carga/descarga
        setState({
            ultimaLecturaDescargaZE: {
                idCargaDescarga: this.props.idDescarga,
                lectura: lectura
            }
        });
    }

    render() {

        return (
            <FolioFisico permiteTeclear={true} onLectura={this.handleOnLectura} mensaje={this.mensaje(this.props)} finalizado={false} />
        );
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/descargaze/edit/lector/index.tsx